export const VERTICALS = {
  0: 'Women',
  1: 'Men',
  2: 'Kids',
  3: 'Home',
  4: 'Beauty'
};

export type Vertical = keyof typeof VERTICALS;
